import { useCallback } from "react";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestMutation from "@/remoteState/useRestMutation";

const useSubmitPowerWordsQuestion = () => {
  const handleSubmitPowerWordsQuestion = useCallback((payload) => {
    return new Request(`${MONOLITH_ORIGIN}/api/v2/student-vocabulary-answer/`, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: { "Content-Type": "application/json" },
    });
  }, []);
  return useRestMutation(handleSubmitPowerWordsQuestion);
};

export default useSubmitPowerWordsQuestion;
